module.exports = __webpack_public_path__ + "static/media/reality.729aa4e5.svg";